export const ExamGroupTranslations = {
  EXAMS_GROUPS: {
    es: 'Convocatorias',
    en: 'Exam groups',
    cat: 'Deialdiak',
    eus: 'Deialdiak',
    pt: 'Convocatorias'
  },
  EXAM_GROUPS_FINDER: {
    es: 'Buscador de convocatorias',
    en: 'Exam groups finder',
    cat: 'Cercador de convocatòries',
    eus: 'Deialdien bilatzailea',
    pt: 'Buscador de convocatórias'
  },
  HOW_DO_EXAM_GROUPS_WORK: {
    es: '¿Cómo funcionan las convocatorias?',
    en: 'How do exam groups work?',
    cat: 'Com funcionen les convocatòries?',
    eus: 'Nola funtzionatzen dute deialdiak?',
    pt: 'Como funcionam as convocatórias?'
  },
  EXAM_GROUPS_EXPLANATION_1: {
    es: 'En Ucademy publicamos todas las convocatorias oficiales del BOE en la plataforma todos los días. Cuando el gobierno autonómico, provincial o estatal pública una convocatoria, no salen siempre todos los datos al principio. Algunos se actualizan más adelante. Cuando el gobierno correspondiente los actualiza, nosotros también.',
    en: 'At Ucademy we publish all the official BOE calls on the platform every day. When the regional, provincial or state government publishes a call, not all the data comes out at the beginning. Some are updated later. When the corresponding government updates them, we do too.',
    cat: "A Ucademy publiquem totes les convocatòries oficials del BOE a la plataforma cada dia. Quan el govern autonòmic, provincial o estatal publica una convocatòria, no surten sempre totes les dades al principi. Algunes s'actualitzen més endavant. Quan el govern corresponent les actualitza, nosaltres també.",
    eus: 'Ucademyk egunero BOEko deialdi ofizial guztiak argitaratzen ditu plataforma. Autonomia, probintzia edo estatuko gobernuak deialdia argitaratzen duenean, ez dira beti datu guztiak agertzen hasieran. Batzuk geroago eguneratzen dira. Gobernu horrek eguneratzen dituenean, guk ere eguneratzen dugu.',
    pt: 'A Ucademy publicamos todas as convocatórias oficiais do BOE na plataforma todos os dias. Quando o governo autónomo, provincial ou estadual publica uma convocatória, nem sempre todos os dados saem no início. Alguns são atualizados mais tarde. Quando o governo correspondente atualiza, nós também.'
  },
  EXAM_GROUPS_EXPLANATION_2: {
    es: 'Así que no te preocupes si hay algún dato en el que pone “No disponible”. Lo actualizaremos en cuanto se publique, y si estás apuntado a la convocatoria, te lo notificaremos.',
    en: "So don't worry if there is any data that says 'Not available'. We will update it as soon as it is published, and if you are signed up for the call, we will notify you.",
    cat: "Així que no et preocupis si hi ha alguna dada que posa 'No disponible'. L'actualitzarem en quant es publiqui, i si estàs apuntat a la convocatòria, t'ho notificarem.",
    eus: 'Beraz, ez kezkatu "Ez dagoela" esaten duen edozein datu. Eguneratuko dugu argitaratzen denean, eta deialdian apuntatuta badagozu, jakinaraziko dizugu.',
    pt: 'Bem, não se preocupe se houver algum dado que diz "Não disponível". Atualizaremos assim que for publicado, e se você está inscrito na convocatória, você será notificado.'
  },
  EXAM_GROUPS_EXPLANATION_3: {
    es: 'Lo mismo con las convocatorias disponibles: Si no la encuentras o ves vacío el listado, es porque no ha salido.',
    en: 'The same with the available calls: If you do not find it or see the list empty, it is because it has not come out.',
    cat: 'El mateix amb les convocatòries disponibles: Si no la trobes o veus buit el llistat, és perquè no ha sortit.',
    eus: 'Berdin deialdiak eskuragarriak direnean: Ez baduzu aurkitzen edo zerrenda hutsa ikusten baduzu, ez da agertu.',
    pt: 'O mesmo com as convocatórias disponíveis: Se não a encontrar ou ver a lista vazia, é porque ainda não saiu.'
  },
  MY_EXAM_GROUPS: {
    es: 'Mis convocatorias',
    en: 'My exam groups',
    cat: 'Les meves convocatòries',
    eus: 'Nire deialdiak',
    pt: 'Minhas convocatórias'
  },
  EXAM_GROUPS_EMPTY: {
    es: 'Aquí aparecerán las convocatorias a las que te apuntes. Todavía no has añadido ninguna convocatoria',
    en: 'Here you will see the exam groups you sign up for. You have not added any exam group yet',
    cat: "Aquí apareixeran les convocatòries a les que t'apuntis. Encara no has afegit cap convocatòria",
    eus: 'Hemen agertuko dira deialdira apuntatzen zara. Oraindik ez duzu deialdirik gehitu',
    pt: 'Aqui aparecerão as convocatórias que se inscreveu. Ainda não adicionou nenhuma convocatória'
  },
  TITLE: {
    es: 'Título',
    en: 'Title',
    cat: 'Títol',
    eus: 'Titulua',
    pt: 'Título'
  },
  TAG: {
    es: 'Formación',
    en: 'Tag',
    cat: 'Formació',
    eus: 'Formakuntza',
    pt: 'Formação'
  },
  TYPE: {
    es: 'Tipo',
    en: 'Type',
    cat: 'Tipus',
    eus: 'Mota',
    pt: 'Tipo'
  },
  PUBLICATION_DATE: {
    es: 'Fecha de publicación',
    en: 'Publication date',
    cat: 'Data de publicació',
    eus: 'Argitaratze data',
    pt: 'Data de publicação'
  },
  STUDENTS: {
    es: 'Alumnos',
    en: 'Students',
    cat: 'Alumnes',
    eus: 'Ikasleak',
    pt: 'Alunos'
  },
  AUTONOMOUS_COMMUNITY: {
    es: 'Comunidad',
    en: 'Autonomous community',
    cat: 'Comunitat',
    eus: 'Autonomia erkidegoa',
    pt: 'Comunidade autónoma'
  },
  ACTIONS: {
    es: 'Acciones',
    en: 'Actions',
    cat: 'Accions',
    eus: 'Ekintzak',
    pt: 'Ações'
  },
  LEAVE_GROUP_CONFIRMATION: {
    es: '¿Estás seguro de que quieres abandonar la convocatoria?',
    en: 'Are you sure you want to leave the exam group?',
    cat: 'Estàs segur que vols abandonar la convocatòria?',
    eus: 'Ziur zaude deialdia utzi nahi duzula?',
    pt: 'Tem certeza que deseja deixar a convocatória?'
  },
  LEAVE_EXAM_GROUP: {
    es: 'Abandonar convocatoria',
    en: 'Leave exam group',
    cat: 'Abandonar convocatòria',
    eus: 'Utzi deialdia',
    pt: 'Deixar convocatória'
  },
  ADD: {
    es: 'Añadir',
    en: 'Add',
    cat: 'Afegir',
    eus: 'Gehitu',
    pt: 'Adicionar'
  },
  EXAM_GROUPS_TOTAL_COUNT: {
    es: '{{total}} convocatorias',
    en: '{{total}} exam groups',
    cat: '{{total}} convocatòries',
    eus: '{{total}} convocatorias',
    pt: '{{total}} convocatórias'
  },
  STATE: {
    es: 'Estatal',
    en: 'State',
    cat: 'Estat',
    eus: 'Estatu',
    pt: 'Estado'
  },
  EXAM_GROUP_STATUS: {
    es: 'Estado',
    en: 'Status',
    cat: 'Estat',
    eus: 'Egoera',
    pt: 'Estado'
  },
  EXAM_GROUP_SEATS: {
    es: 'Plazas',
    en: 'Seats',
    cat: 'Plazas',
    eus: 'Plazak',
    pt: 'Plazas'
  },
  EXAM_GROUP_PUBLICATION: {
    es: 'Publicación',
    en: 'Publication',
    cat: 'Publicació',
    eus: 'Argitaratzea',
    pt: 'Publicação'
  },
  EXAM: {
    es: 'Examen',
    en: 'Exam',
    cat: 'Examen',
    eus: 'Examen',
    pt: 'Exame'
  },
  NOT_FOLLOWING_ANY_EXAM_GROUP: {
    es: 'No sigues ninguna convocatoria',
    en: 'You are not following any exam group',
    cat: 'No sigues cap convocatòria',
    eus: 'Ez dituzu deialdirik jarraitu',
    pt: 'Não está seguindo nenhuma convocatória'
  },
  ADD_EXAMS_GROUPS_TO_CONTROL_YOUR_GOAL: {
    es: 'Añade una convocatoria para tener tu meta a la vista',
    en: 'Add an exam group to have your goal in view',
    cat: 'Afegeix una convocatòria per tenir la teva meta a la vista',
    eus: 'Deialdirik gehitu meta zure ikuspegiera',
    pt: 'Adicione uma convocatória para ter sua meta visível'
  },
  OBSERVATIONS: {
    es: 'Observaciones',
    en: 'Observations',
    cat: 'Observacions',
    eus: 'Oharrak',
    pt: 'Observações'
  }
};
